import Axios from 'axios';
import { encodeQueryParams } from '../utils/helper';
import * as Constants from '../constants';

const fetchMiddleware = store => next => action => {
  const dispatch = store.dispatch;
  const type = action.type;
  const actionType = action.actionType;
  if (actionType === 'custom') {
    dispatch({ type: `${type}_START` });
  }
  if (!action || !action.fetchConfig) {
    return next(action);
  }

  const config = action.fetchConfig;
  const host = config.host;
  const path = config.path;
  const method = config.method;
  const queryParams = config.queryParams;
  const successCb = action.successCb;
  const requestBody = config.body;
  const timeout = config.timeout || 0;
  const requestHeaders = config.requestHeaders || {};
  let queryString;
  // get query string from query params
  let url = `${host}${path}`;
  if (queryParams && Object.keys(queryParams).length) {
    queryString = encodeQueryParams(queryParams);
    url = `${url}?${queryString}`;
  }

  const fetchParams = {
    method,
    timeout,
    mode: 'cors',
    headers: Object.assign({
      'Content-Type': 'application/json'
    }, requestHeaders),
  };
  if (method.toLowerCase() === 'post' || method.toLowerCase() === 'patch' || method.toLowerCase() === 'put') {
    fetchParams.data = requestBody || {};
  }
  return Axios({
    url,
    ...fetchParams,
  })
  .then((response = {}) => {
    const { data: responseData } = response;
    if ((responseData && responseData.status === 1) || (path.startsWith('/v5') && response.status === 200)) {
      dispatch({ queryParams, data: responseData, type: `${type}_SUCCESS` });
    } else {
      responseData.status = 0;
      dispatch({ queryParams, data: responseData, type: `${type}_FAILURE` });
    }
    return responseData;
  })
  .catch((error = {}) => {
    const message = error && error.message;
    if (message && message.includes('timeout')) {
      /* API timeout handling */
      return {
        error: {
          message: '',
          show_alert: false,
        },
        status: 0,
        data: null,
      };
    }
    const { response: { status: statusCode, data: errorData } = {} } = error;

    if (type === Constants.CREATE_ORDER && path.startsWith('/v5') && [400, 500].includes(statusCode)) {
      dispatch({data: errorData, type: `${type}_FAILURE`});
      return errorData;
    }

    // Check for Diagnostic 404
    if (host === Constants.API_HOST_DIAG && statusCode === 404 && errorData) {
      dispatch({ data: errorData, type: `${type}_FAILURE` });
      return errorData;
    }

    if (type === Constants.PLACE_DIAGNOSTICS_ORDER && statusCode === 400 && errorData) {
      dispatch({ data: errorData, type: `${type}_FAILURE` });
      return errorData;
    }

    if (statusCode === 401) {
      dispatch({ data: { error, status: 0 }, type: Constants.AGENT_LOGOUT_SUCCESS });
    } else {
      Raven.captureException(`${type}_FAILURE_API`, {
        extra: {
          URL: url,
          REQUEST_PARAMS: fetchParams,
          STATUS_CODE: statusCode,
          RESPONSE: error,
          MESSAGE: error.message,
        },
        fingerprint: ['{{ default }}', `${type}_FAILURE_API`],
      });
    }
    const errorInfo = {
      status: 0,
      error: { message: error.message || `Status Code: ${statusCode}` },
    };
    dispatch({ data: errorInfo, type: `${type}_FAILURE` });

    return errorData;
  }).then(data => {
    if (typeof successCb === 'function') {
      successCb(data);
    }
  });
};

export default fetchMiddleware;
